import React from 'react';

import InfoBlock from '@components/infoBlock/InfoBlock.tsx';

import I from '../types.ts';

import ArticlePreview from '../../articlePreview/ArticlePreview.tsx';

const renderArticle: I['renderArticle'] = function ({ item, prop: id }) {
    if (id === 'info') {
        return (
            <div className="publicBlog__article _info">
                <div className="publicBlog__articleInner">
                    <InfoBlock
                        className="_public"
                        title={item.counter === 0 ? 'Пусто' : 'Это все статьи'}
                        description={
                            item.counter === 0
                                ? 'Пока что материалов <br />в данном разделе нет'
                                : 'Пока что это все материалы,<br />которые есть в данном разделе'
                        }
                    />
                </div>
            </div>
        );
    }

    return (
        <div className={`publicBlog__article ${item.isMain ? '_main' : ''}`}>
            <div className="publicBlog__articleInner">
                <ArticlePreview article={item} />
            </div>
        </div>
    );
};

export default renderArticle;
